import React, { useRef, useCallback } from 'react';
import { useDetailsPanel } from '@/contexts/DetailsPanelContext';
import { useLocation } from 'react-router-dom';
import { useEventListener } from '@/hooks/useEventListener';
import { DetailsPanel } from './index';

interface DetailsPanelWrapperProps {
  isRoom: boolean;
  isZone: boolean;
}

export const DetailsPanelWrapper: React.FC<DetailsPanelWrapperProps> = ({ isRoom, isZone }) => {
  const { isOpen, close } = useDetailsPanel();
  const { pathname } = useLocation();
  const panelRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: Event) => {
      const target = event.target as Element;
      const panelElement = panelRef.current;
      const gearButton = document.querySelector('[data-id="showHideDetails"]');

      const isClickInsidePanel = panelElement?.contains(target);
      const isClickOnGearButton = gearButton?.contains(target) || gearButton === target;

      // Check if click is on dropdown portals
      const isClickOnDropdown =
        target.closest('[data-radix-popper-content-wrapper]') || // Radix popover/select portals
        target.closest('[role="listbox"]') || // Select dropdown
        target.closest('[role="option"]'); // Select option

      if (!isClickInsidePanel && !isClickOnGearButton && !isClickOnDropdown) {
        close();
      }
    },
    [close],
  );

  // Only attach the event listener when the panel is open
  useEventListener('mousedown', isOpen ? handleClickOutside : () => {}, document, {
    capture: true,
  });

  if (!isOpen) {
    return null;
  }

  return (
    <div ref={panelRef} className="right-0 top-0 h-full z-20 shadow-lg bg-white">
      <DetailsPanel isRoom={isRoom} isZone={isZone} isStudio={pathname === '/studio'} />
    </div>
  );
};
